export default "__VITE_ASSET__CaXE5UG$__"